<template>
  <v-list-item v-bind="$attrs" :disabled="disabled" :style="{ color }" @click="$emit('click', $event)" :density="density">
    <template #prepend>
      <component v-if="computedIcon" :is="computedIcon" class="list-item-icon" />
    </template>
    <v-list-item-title class="list-item-title">{{ title }}</v-list-item-title>
  </v-list-item>
</template>

<script>
import { getIcon } from "@/components/utils/utils";

export default {
  name: "ListItem",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: Function,
      default: null,
    },
    iconType: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: "var(--dark-color)",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    density: {
      type: String,
      default: "compact",
    },
  },
  emits: ["click"],
  computed: {
    computedIcon() {
      return getIcon(this.icon, this.iconType);
    },
  },
};
</script>

<style scoped>
.list-item-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  stroke-width: 1.5;
}

.list-item-title {
  font-size: 0.9rem;
}
</style>
